import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from '@phosphor-icons/react';

function Quotes({ embedded = false }) {
  const navigate = useNavigate();

  return (
    <div className={embedded ? '' : 'min-h-screen bg-[#F9F8F6]'} data-testid="quotes-page">
      {/* Header */}
      {!embedded && (
      <header className="bg-white border-b border-[#E8E6E1]">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-6 flex items-center justify-between">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-[#5E5A56] hover:text-[#2C2A28] transition-colors"
            data-testid="back-button"
          >
            <ArrowLeft size={20} />
            <span className="text-sm font-medium">Back to Dashboard</span>
          </button>
          <div className="flex items-center gap-3">
            <img 
              src="https://static.prod-images.emergentagent.com/jobs/b48706df-2eab-4a16-a663-66b78a54e225/images/02f1d6f45fd218419535b4d63b62b9bbee6f2e7df5a15d9bf8eb07204bbb5662.png" 
              alt="Sacred Symbol" 
              className="w-10 h-10 object-contain"
            />
            <h1 className="font-heading text-3xl font-medium text-[#2C2A28] tracking-tight">BKAgriD</h1>
          </div>
          <div className="w-32"></div>
        </div>
      </header>
      )}

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-24">
        <div className="text-center mb-16">
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-medium text-[#2C2A28] mb-6 tracking-tight">
            Words of Wisdom
          </h2>
          <p className="text-base text-[#5E5A56] max-w-2xl mx-auto leading-relaxed">
            Inspiration for students and scientists on their journey of discovery
          </p>
        </div>

        {/* OSHO Quote for Students */}
        <div
          className="relative mb-12 rounded-[32px] overflow-hidden"
          style={{
            backgroundImage: 'url(https://images.unsplash.com/photo-1762186058472-cc700178df9e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwyfHxjYWxtJTIwbWVkaXRhdGlvbiUyMGFic3RyYWN0fGVufDB8fHx8MTc3NTEwODM1N3ww&ixlib=rb-4.1.0&q=85)',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
          data-testid="osho-quote-section"
        >
          <div className="bg-gradient-to-br from-[#2C2A28]/80 to-[#5E5A56]/70 backdrop-blur-sm p-16 sm:p-20 lg:p-24">
            <div className="max-w-4xl mx-auto text-center">
              <p className="text-xs uppercase tracking-[0.3em] font-bold text-white/70 mb-6">For Students</p>
              <blockquote className="font-quote text-3xl sm:text-4xl lg:text-5xl text-white mb-8 leading-relaxed italic" data-testid="osho-quote-text">
                "The moment a child is born, the mother is also born. She never existed before. The woman existed, but the mother, never. A mother is something absolutely new."
              </blockquote>
              <p className="font-quote text-xl text-white/90" data-testid="osho-attribution">
                — OSHO
              </p>
            </div>
          </div>
        </div>

        {/* Brahmakumaris Quote for Scientists */}
        <div
          className="relative rounded-[32px] overflow-hidden"
          style={{
            backgroundImage: 'url(https://images.pexels.com/photos/2909066/pexels-photo-2909066.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940)',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
          data-testid="brahmakumaris-quote-section"
        >
          <div className="bg-gradient-to-br from-[#6B8E7B]/90 to-[#2C2A28]/80 backdrop-blur-sm p-16 sm:p-20 lg:p-24">
            <div className="max-w-4xl mx-auto text-center">
              <p className="text-xs uppercase tracking-[0.3em] font-bold text-white/70 mb-6">For Scientists</p>
              <blockquote className="font-quote text-3xl sm:text-4xl lg:text-5xl text-white mb-8 leading-relaxed italic" data-testid="brahmakumaris-quote-text">
                "Knowledge is the foundation of wisdom. When knowledge is applied with understanding and compassion, it transforms into wisdom that serves humanity."
              </blockquote>
              <p className="font-quote text-xl text-white/90" data-testid="brahmakumaris-attribution">
                — Brahmakumaris
              </p>
            </div>
          </div>
        </div>

        {/* Additional Inspirational Section */}
        <div className="mt-16 bg-white rounded-[24px] border border-[#E8E6E1] shadow-sm p-10 text-center">
          <h3 className="font-heading text-2xl font-medium text-[#2C2A28] mb-4">
            The Journey of Discovery
          </h3>
          <p className="text-base text-[#5E5A56] leading-relaxed max-w-3xl mx-auto">
            Whether you are a student beginning your research journey or a scientist pushing the boundaries of knowledge, remember that every data point tells a story, every analysis reveals patterns, and every discovery contributes to humanity's collective wisdom. May your work be guided by curiosity, integrity, and compassion.
          </p>
        </div>
      </main>
    </div>
  );
}

export default Quotes;